import { EventDisplayComponentProps, EventInfo } from "@/types"
import { Table } from "@chakra-ui/react"

const EventDisplayComponent = (props: EventDisplayComponentProps) => {

    const event: EventInfo = props.event

    return (
        <Table.Root size="sm">
        <Table.Body>
            <Table.Row>
            <Table.Cell>Name:</Table.Cell> <Table.Cell>{event.name}</Table.Cell>
            </Table.Row>
            <Table.Row>
            <Table.Cell>Date:</Table.Cell> <Table.Cell>{event.date}</Table.Cell>
            </Table.Row>
            <Table.Row>
            <Table.Cell>Start Time:</Table.Cell> <Table.Cell>{event.start_time}</Table.Cell>
            </Table.Row>
            <Table.Row>
            <Table.Cell>End Time:</Table.Cell> <Table.Cell>{event.end_time}</Table.Cell>
            </Table.Row>
            <Table.Row>
            <Table.Cell>Location:</Table.Cell> <Table.Cell>{event.location}</Table.Cell>
            </Table.Row>
        </Table.Body>
        </Table.Root>
            )
}

export default EventDisplayComponent